import { SearchCriteria } from "./search-criteria";

export class AccountTypeCriteria extends SearchCriteria
{

}